export default __webpack_public_path__ + "static/media/ORCID-Badge-v-02-DISPLAY.62d33d48.svg";